/**
 * Tipo de questão de uma prova gerada por IA, espelhando o enum `EBotExamType`
 * do backend (campo numérico `type` dos DTOs de revisão/tradução/visualização).
 */
export enum EBotExamType {
  Default = 1,
  TrueFalse = 2,
  MultipleAffirmations = 3,
  FillInTheBlanks = 4,
}
